module.exports = __webpack_public_path__ + "static/media/tickIcon34.24227cef.svg";